import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import WhiteCard from "src/shared/components/WhiteCard";
import { useIsMobile } from "src/hooks/useIsMobile";
import { MedicationIcon } from "src/shared/components/MedicationIcon";

interface Props {
  onNext: () => void;
}

const AmhImage = ({ onNext }: Props) => {
  const { t } = useTranslation();
  const page = "amg-image";
  const isMobile = useIsMobile();
  return (
    <WhiteCard
      gap={1}
      sx={{
        background:
          "linear-gradient(180deg, #F8F8F8 0%, rgba(0, 181, 184, 0.55) 100%)",
        borderRadius: "30px",
      }}
      onClick={onNext}
    >
      <Typography color="#0E888A" variant="h5" fontWeight={500}>
        {t("medications.mental health.capitalized")}
      </Typography>
      <Stack>
        <Typography variant="h6">
          {t(`${page}.subtext`, "SSRI + Supplements")}
        </Typography>
        <Typography variant="h6" fontStyle={"italic"}>
          {t(`${page}.disclaimer`, "Rx support to feel like yourself again")}
        </Typography>
      </Stack>
      <MedicationIcon
        name={"Tadalafil"}
        slug="ed-ot"
        width={isMobile ? 240 : 300}
        height={isMobile ? 240 : 300}
        sx={{ alignSelf: "center", transform: "rotate(-20deg)" }}
      />
    </WhiteCard>
  );
};

export default AmhImage;
